export type InfoContent = {
  content: string;
};

const CORPORATION_DEFAULT_INFO: InfoContent[] = [
  { content: '환급액은 제휴 세무사와 국세청 검토 후 결정되며, 검토 과정에서 일부 변동될 수 있어요.' },
  { content: '환급이 완료되면 제휴 세무사가 이용료 결제를 요청드려요.' }
];

const individualInfoBase = (hasRegisteredCard: boolean): InfoContent[] => [
  { content: '환급액은 제휴 세무사와 국세청 검토 후 결정되며, 검토 과정에서 일부 변동될 수 있어요.' },
  {
    content: hasRegisteredCard ? '환급이 완료되면 등록된 결제 카드로 이용료가 자동 결제돼요.' : '환급이 완료되면 세무 이용료를 결제 요청드려요.'
  }
];

export const getCorporationDefaultInfo = (): InfoContent[] => [...CORPORATION_DEFAULT_INFO];
export const getIndividualDefaultInfo = (hasRegisteredCard: boolean = false): InfoContent[] => individualInfoBase(hasRegisteredCard);
